export default __webpack_public_path__ + "static/media/gallery_12.efce3c70.jpg";